import React from 'react';
import Footer from './Footer';

function Home () {
    return(
        <div>
            <p className="box1">
            There are always <span>more proper</span> answers rather than only <span>one right</span> answer.<br/>
            </p>
            <Footer className="footer1" />
        </div>
    )
}

export default Home;